<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import WorkOrderTablePropertyCell from "../../../../../../_shared/_modules/work-order-table-property-cell"
  import type { VerifyCustomerDraft, VerifyCustomerRow } from "../../contract"

  let props: InboxWorkflowCellProps<VerifyCustomerRow, VerifyCustomerDraft> = $props()

  const row = $derived(props.row)
</script>

<WorkOrderTablePropertyCell
  addressLabel={row.addressLabel}
  unitLabel={row.unitLabel}
  disabled={row.disabled}
/>
